var _path, _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanWizard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scan-wizard-icon",
    width: 55,
    height: 61,
    viewBox: "0 0 55 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 15V33L27.5 61L0 46V15L27.5 0L55 15ZM45.0537 33.2617L38.165 42.0928L34.9189 38.2285L34.1475 37.3096L32.3096 38.8525L33.0811 39.7715L37.2812 44.7715L38.2344 45.9072L39.1465 44.7383L46.9463 34.7383L47.6846 33.792L45.792 32.3154L45.0537 33.2617ZM7.7998 44.2002H25.2002V41.7998H7.7998V44.2002ZM7.7998 36.2002H25.2002V33.7998H7.7998V36.2002ZM7.7998 23.7998V26.2002H15.0967V23.7998H7.7998ZM21.9473 23.7998V26.2002H47.2002V23.7998H21.9473ZM7.7998 19.2002H33.0527V16.7998H7.7998V19.2002ZM39.9033 19.2002H47.2002V16.7998H39.9033V19.2002Z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #scan-wizard-icon path {\n            fill: url(#bg);\n        }\n\n        .dark #scan-wizard-icon path {\n            fill: url(#bg-dark);\n        }\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 30.5) rotate(90) scale(30.5 31.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D8FFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg-dark",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29 26) rotate(87.546) scale(35.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EC48D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanWizard);
export default __webpack_public_path__ + "static/media/scan-wizard.0303d2fd86d3b0568a9d134463886b56.svg";
export { ForwardRef as ReactComponent };